import React from 'react';
import { SolarAccelerationMetrics } from '../../services/solarAccelerationService';
import { KeyMetrics, KeyMetric } from './KeyMetrics';

interface SolarAccelerationMetricsProps {
  metrics: SolarAccelerationMetrics;
}

const SolarAccelerationMetricsComponent: React.FC<SolarAccelerationMetricsProps> = ({ metrics }) => {
  return (
    <KeyMetrics>
      <KeyMetric
        value={`${metrics.latestYearGrowthRate.toFixed(1)}%`}
        label="Latest Growth Rate"
        color="#8b5cf6"
      />
      <KeyMetric
        value={`${metrics.fiveYearCAGR.toFixed(1)}%`}
        label="5-Year CAGR"
        color="#f59e0b"
      />
      <KeyMetric
        value={`${metrics.peakGrowthYear}`}
        label="Peak Growth Year"
        color="#10b981"
      />
      <KeyMetric
        value={metrics.onTrackToTarget ? '✓ On Track' : '⚠ Below Target'}
        label="2030 Target Status"
        color={metrics.onTrackToTarget ? '#10b981' : '#ef4444'}
      />
    </KeyMetrics>
  );
};

export default SolarAccelerationMetricsComponent;
